export default function isInteger(value) {
  return /^-?[0-9]+$/.test(value) && !Number.isNaN(Number(value));
}
